import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import '@vivest-dev/design-system-web-components';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
